// src/services/projectService.js
import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Eliminar un rotador
export const deleteRotator = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/project/orbit-view/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Obtener un rotador por su ID
export const getRotatorById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/orbit-view/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getRotatorsByProyectId = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project/orbit-views/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

// Actualizar un rotador existente
export const saveRotator = async (rotator) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/project/orbit-view`, rotator);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
